(function($) {

	$('.prodSlider').not('.slick-initialized').slick({
		infinite: true,
		slidesToShow: 1,
		swipeToSlide: true,
		fade: true,
		arrows: false,
		dots: true,
		appendDots: '.prodSlider__nav',
		dotsClass: 'prodSlider__navDots',
		autoplay: false,
		speed: 800,
		customPaging: function(slick,index) {
			var tnImage = slick.$slides.eq(index).find('img').attr('src');
			return '<img src=" ' + tnImage + ' " class="prodSlider__navTN">';
		}
	});

	var filtered = false;
	$(window).on('load', function() {
		$('.prodSlider').slick('slickUnfilter').slick('slickFilter','.model01');
		filtered = true;
	});
	$('.js-model').on('click',function(){
		var filter = $(this).data('model');
		$('.prodSlider').slick('slickUnfilter').slick('slickFilter','.'+filter);
		filtered = true;
	});
})(jQuery);